module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showModal) ? _c('div', [(_vm.largeSize == true) ? _c('div', {
    staticClass: "ix-modal__large"
  }, [_c('button', {
    staticClass: "ix-modal__close",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ix-modal__content"
  }, [_c(_vm.currentModalView, {
    tag: "component"
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mobile == true & _vm.largeSize == false) ? _c('div', {
    staticClass: "ix-modal__small"
  }, [_c('button', {
    staticClass: "ix-modal__close",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ix-modal__content"
  }, [_c(_vm.currentModalView, {
    tag: "component"
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.mobile == false & _vm.largeSize == false) ? _c('div', {
    staticClass: "ix-modal"
  }, [_c('button', {
    staticClass: "ix-modal__close",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ix-modal__content"
  }, [_c(_vm.currentModalView, {
    tag: "component"
  })], 1)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c23446","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 1520
// module chunks = 4